/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { spendRulesEventsList } from "../funcs/spendRulesEventsList.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { ListSpendRuleEventsResult } from "../models/components/listspendruleeventsresult.js";
import {
  ListSpendRuleEventsRequest,
  ListSpendRuleEventsSecurity,
} from "../models/operations/listspendruleevents.js";
import { unwrapAsync } from "../types/fp.js";

export class Events extends ClientSDK {
  /**
   * listSpendRuleEvents spendRules
   *
   * @remarks
   * List warning and breach events emitted by budget rule evaluation, most recent first.
   */
  async list(
    request?: ListSpendRuleEventsRequest | undefined,
    security?: ListSpendRuleEventsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListSpendRuleEventsResult> {
    return unwrapAsync(spendRulesEventsList(
      this,
      request,
      security,
      options,
    ));
  }
}
